<div *ngIf="!loading; else cargando" class="informes">
  <h2 style="text-align: center">INFORME MAE</h2>
  <div class="report-pres">
    <div class="grid-container">
      <div class="grid-item i1">
        <em>REPORT EN CURSO: {{ report.uuid }}</em>
      </div>
      <div class="grid-item i2">
        <em>CODIGO : {{ report.codigo }}</em>
      </div>
      <div class="grid-item i3" *ngIf="reportEdit">
        <em>TITULO:&nbsp;</em>
        <input class="input-report" type="text" [(ngModel)]="report.titulo" />
      </div>
      <div class="grid-item i3" *ngIf="!reportEdit">
        <em>TITULO:&nbsp;{{ report.titulo }}</em>
      </div>
      <div class="grid-item i4" *ngIf="reportEdit">
        <em>IDIOMA:&nbsp;</em
        ><input class="input-report" type="text" [(ngModel)]="report.idioma" />
      </div>
      <div class="grid-item i4" *ngIf="!reportEdit">
        <em>IDIOMA:&nbsp;{{ report.idioma }}</em>
      </div>
      <div class="grid-item i5" *ngIf="reportEdit">
        <em>DESCRIPCION:&nbsp;</em>
        <input
          class="input-report"
          type="text"
          [(ngModel)]="report.descripcion"
        />
      </div>
      <div class="grid-item i5" *ngIf="!reportEdit">
        <em>DESCRIPCION:&nbsp;{{ report.descripcion }}</em>
      </div>
      <div class="grid-item i6"><em>&nbsp;</em></div>
      <div class="grid-item i7" *ngIf="reportEdit">
        <em>LOGO:&nbsp;</em>
        <input class="input-report" type="text" [(ngModel)]="report.logo" />
      </div>
      <div class="grid-item i7" *ngIf="!reportEdit">
        <em>LOGO:&nbsp;{{ report.logo }}</em>
      </div>
      <div class="grid-item i8"><img [src]="report.logo" width="150px" /></div>
      <div class="grid-item i9" *ngIf="reportEdit">
        <div>
          <em>IMAGEN:&nbsp;</em>
          <input class="input-report" type="text" [(ngModel)]="report.imagen" />
        </div>
        <!--<div><em>FECHA IMPLEMENTACION:&nbsp;</em> <input class="input-report" type="text" [(ngModel)]="report.fechaImplantacion"></div>-->
        <form>
          <div>
            <label for="fecimple">FECHA IMPLEMENTACION:</label>
            <input
              type="date"
              id="fecimple"
              name="fecimple"
              [(ngModel)]="fim"
            />
          </div>
        </form>
        <!---->
      </div>
      <div class="grid-item i9" *ngIf="!reportEdit">
        <div>
          <em>IMAGEN:&nbsp;{{ report.imagen }}</em>
        </div>
        <div>
          <em
            >FECHA IMPLEMENTACION:&nbsp;<br />{{ report.fechaImplantacion }}</em
          >
        </div>
      </div>
      <div class="grid-item i10">
        <img [src]="report.imagen" width="150px" />
      </div>
      <div class="grid-item i11">&nbsp;</div>
      <div class="grid-item i12">&nbsp;</div>
      <div class="grid-item i13">
        <button mat-button color="primary" (click)="editReport()">
          <mat-icon>create</mat-icon>
        </button>
      </div>
      <div class="grid-item i14">
        <a class="mat-raised-button binfo" routerLink="/informes"> Volver </a>
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="editreportparam">
    <div>
      <strong>FABRICA:</strong><br />
      <div *ngIf="reportEditParam" mat-dialog-content>
        <mat-form-field>
          <mat-select (selectionChange)="changeFabrica($event.value)">
            <mat-option *ngFor="let f of fab; let i = index" [value]="f">{{
              f.nombre
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;&nbsp;&nbsp;&nbsp;{{ registro.fabrica.fabnombre }} &nbsp;
        &nbsp;[{{ registro.fabrica.fabuuid }}]
      </div>
      <div *ngIf="!reportEditParam">
        &nbsp;&nbsp;&nbsp;&nbsp;{{ registro.fabrica.fabnombre }} &nbsp;
        &nbsp;[{{ registro.fabrica.fabuuid }}]
      </div>
    </div>
    <div>&nbsp;</div>
    <div>
      <strong>DISPOSITIVO:</strong><br />
      <div *ngIf="reportEditParam" mat-dialog-content>
        <mat-form-field>
          <mat-select (selectionChange)="changeDispositivo($event.value)">
            <mat-option *ngFor="let d of disfab; let i = index" [value]="d">{{
              d
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;&nbsp;&nbsp;&nbsp;{{ registro.dispositivo.disnombre }} &nbsp;
        &nbsp;[{{ registro.dispositivo.disuuid }}]
      </div>
      <div *ngIf="!reportEditParam">
        &nbsp;&nbsp;&nbsp;&nbsp;{{ registro.dispositivo.disnombre }} &nbsp;
        &nbsp;[{{ registro.dispositivo.disuuid }}]
      </div>
    </div>
    <div>&nbsp;</div>
    <div>
      <strong>MENSUAL:</strong><br />
      <div *ngIf="reportEditParam" mat-dialog-content>
        <mat-form-field>
          <mat-select (selectionChange)="changeMensual($event.value)">
            <mat-option *ngFor="let td of tdmdis; let i = index" [value]="td">{{
              td
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;&nbsp;&nbsp; &nbsp;{{ registro.mensual.tdnombre }} &nbsp;
        &nbsp;[{{ registro.mensual.tduuid }}]
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;unidadT:&nbsp;&nbsp;<input
            class="input-report"
            type="text"
            [(ngModel)]="registro.mensual.unidadT"
          />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unidadK:&nbsp;&nbsp;<input
            class="input-report"
            type="text"
            [(ngModel)]="registro.mensual.unidadK"
          />
        </div>
      </div>
      <div *ngIf="!reportEditParam">
        &nbsp;&nbsp;&nbsp; &nbsp;{{ registro.mensual.tdnombre }} &nbsp;
        &nbsp;[{{ registro.mensual.tduuid }}]
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;unidadT:&nbsp;&nbsp;{{
            registro.mensual.unidadT
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unidadK:&nbsp;&nbsp;{{
            registro.mensual.unidadK
          }}
        </div>
      </div>
    </div>
    <div>&nbsp;</div>
    <div>
      <strong>HORARIO:</strong><br />
      <div *ngIf="reportEditParam" mat-dialog-content>
        <mat-form-field>
          <mat-select (selectionChange)="changeHorario($event.value)">
            <mat-option *ngFor="let td of tdhdis; let i = index" [value]="td">{{
              td
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        &nbsp;&nbsp;&nbsp; &nbsp;{{ registro.horario.tdnombre }} &nbsp;
        &nbsp;[{{ registro.horario.tduuid }}]
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;unidadT:&nbsp;&nbsp;<input
            class="input-report"
            type="text"
            [(ngModel)]="registro.horario.unidadT"
          />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unidadK:&nbsp;&nbsp;<input
            class="input-report"
            type="text"
            [(ngModel)]="registro.horario.unidadK"
          />
        </div>
      </div>
      <div *ngIf="!reportEditParam">
        &nbsp;&nbsp;&nbsp; &nbsp;{{ registro.horario.tdnombre }} &nbsp;
        &nbsp;[{{ registro.horario.tduuid }}]
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;unidadT:&nbsp;&nbsp;{{
            registro.horario.unidadT
          }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;unidadK:&nbsp;&nbsp;{{
            registro.horario.unidadK
          }}
        </div>
      </div>
    </div>
    <div>&nbsp;</div>
    &nbsp;&nbsp;&nbsp;&nbsp;<button
      mat-button
      color="primary"
      (click)="editReportParam()"
    >
      <mat-icon>create</mat-icon>
    </button>
  </div>
</div>
<div class="espera">
  <ng-template #cargando>
    <mat-spinner class="espera"></mat-spinner>
    <span>Cargando ..</span>
  </ng-template>
</div>
